<template>
    <!-- Start Allow Us To Help -->
    <div id="allow-help" class="container-fluid">
      <div class="container">
        <h2>ALLOW US TO HELP</h2>
        <p class="help-intro-text" v-if="!cotto">We would love to talk with you and help you find products and solutions matched to your project needs. After completing the form below, a Florida Tile Sales Representative will contact you within one business day.</p>
        
        <p class="help-intro-text" v-else>We would love to talk with you and help you find products and solutions matched to your project needs. After completing the form below, a Cotto d'Este USA Sales Representative will contact you within one business day.</p>
        <div class="row">
          <div class="col allow-help-left-col">
            <h3>CONTACT A REPRESENTATIVE</h3>
            <form class="commercial-form">
              <select v-model="interest" class="interested-in">
                <option value='' selected disabled>*I’m interested in -- Select a topic ---</option>
                <option>Presentation</option>
                <option>Product samples</option>
                <option>Sustainability information</option>
                <option>Technical information</option>
                <option>Project specific inquiry</option>
                <option>National/Regional Account</option>
              </select>
              <select v-model="role" class="i-am-a">
                <option value='' selected disabled>*I am a -- Select your type --</option>
                <option>Interior Designer/Architect</option>
                <option>Architect</option>
                <option>Landscape Architect</option>
                <option>Facilities</option>
                <option>Commercial End-User</option>
                <option>Commercial business owner</option>
                <option>Developer</option>
                <option>Flooring Contractor</option>
                <option>General Contractor</option>
                <option>Student of Architecture or Design</option>
              </select>
              <input v-model="firstName" class="first-name left-text" type="text" id="fname" placeholder="*First Name">
              <input v-model="lastName" class="last-name right-text" type="text" id="lname" placeholder="*Last Name">
              <input v-model="company" class="company left-text" type="text" id="company" placeholder="*Company name">
              <input v-model="state" class="state right-text" type="text" id="state" placeholder="*State/Providence">
              <input v-model="phone" class="phone left-text" type="text" id="phone" placeholder="*Phone">
              <input v-model="email" class="email right-text" type="text" id="email" placeholder="*Email">
              <b-form-textarea v-model="comments" class="comments" type="text" id="comments" placeholder="*Comments" rows="5"></b-form-textarea>
              <div class="submit">
                
                <div class="submit-captcha-container">
                  <vue-recaptcha
                    class="contact-captcha"
                    ref="recaptcha"
                    @verify="recaptchaVerify"
                    @expired="recaptchaExpired"
                    :sitekey="'6Ld0CcgqAAAAAMYX_CdSg5hzVAIGJ8NtUtNVC5eu'">
                  </vue-recaptcha>
                  <input class="commercial-submit" type="submit" value="Submit" @click.prevent="submitContactForm()">
                </div>
                
              </div>
            </form>
            <!--<div class="commercial-sales-specialist">-->
            <!--  <div>-->
            <!--    <p>Commercial Sales Specialists and Independent Channel Regional Sales Managers</p>-->
            <!--  </div>-->
            <!--  <div class="view-listings">-->
            <!--    <a class="commercial-button" href="/#">View Listings</a>-->
            <!--  </div>-->
            <!--</div>-->
            <div class="clearfix"></div>
          </div>
          <div class="col allow-help-right-col">
            <h3>ORDER SAMPLES</h3>
            <p class="allow-help-para">To request samples from a Florida Tile distributor located close to you, follow the link below.</p>
            <a class="order-button top-order-btn" href="/sample-information">Sample Information</a>
            
            <div class="material-bank">
              <img src="https://d24qrurc3qms3u.cloudfront.net/core/images/material-bank-logo.jpg">
              <p>If you are a member of Material Bank, order your FREE samples here for delivery within 24 hours.</p>
              <a class="order-button" target="_blank" href="https://www.materialbank.com/partner/floridatile">Find Out More</a>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    <!-- End Allow Us To Help -->
</template>


<script>
  import VueRecaptcha from 'vue-recaptcha'
  import { required, email, integer, minLength, maxLength } from 'vuelidate/lib/validators'
  import { commercialForm } from '../graphql/mutations'
  import global_mixin from '../js/global_mixins.js'
  export default {
    components: {
      VueRecaptcha
    },
    props: ['cotto'],
    data() {
      return {
        interest: '',
        role: '',
        firstName: '',
        lastName: '',
        company: '',
        state: '',
        phone: '',
        email: '',
        comments: '',
        recaptchaResponse: null
      }
    },
    validations: {
      interest: { required },
      role: { required },
      firstName: { required },
      lastName: { required },
      company: { required },
      state: { required },
      phone: { required },
      email: { required, email },
      comments: { required }
    },
    apollo: {},
    methods: {
      recaptchaVerify(response) {
        this.recaptchaResponse = response
      },
      recaptchaExpired() {
        this.$refs.recaptcha.reset()
      },
      async submitContactForm() {
        this.isLoading = true
        this.$v.$touch()
        if (this.$v.$invalid || this.recaptchaResponse === null) {
          if (this.recaptchaResponse === null) {
            this.addAlert('Please verify that you are not a robot!', 'danger')
            this.isLoading = false
          }
          else {
            this.addAlert('Form is not valid! Please check your submission.', 'danger')
            this.isLoading = false
          }
        }
        else {
          try {
            //          let response = await this.$http.post('/api/public/v1/', {
            //            'action': 'submit_contact_form',
            //            'contactFor': this.contactFor,
            //            'contactName': this.contactName,
            //            'contactCompany': this.contactCompany,
            //            'contactCity': this.contactCity,
            //            'contactState': this.contactState,
            //            'contactZip': this.contactZip,
            //            'contactComments': this.contactComments,
            //            'contactEmail': this.contactEmail,
            //            'contactPhone': this.contactPhone,
            //            'receiveNewsletter': this.receiveNewsletter,
            //            'recaptchaResponse': this.recaptchaResponse
            //          })

            let success = this.$apollo.mutate({
              mutation: commercialForm,

              variables: {
                interest: this.interest,
                role: this.role,
                firstName: this.firstName,
                lastName: this.lastName,
                company: this.company,
                state: this.state,
                phone: this.phone,
                email: this.email,
                comments: this.comments,
                recaptchaResponse: this.recaptchaResponse,
                cotto: this.cotto
              }
            })
            console.log("Was it successful?")
            console.log(success)
            if (success) {
              this.addAlert('You have successfully submitted the contact form! We will reach out to you shortly.', 'success')
              if(this.cotto){
                location.href = '/cottodeste/thank-you';
              } else {
                location.href = '/commercial/thank-you';
              }
              
            }
            else {
              this.addAlert('There was an error submitting your contact request!', 'danger')
            }
            this.isLoading = false
          }
          catch (error) {
            console.log(error)
            if (error.response.data.error) {
              this.addAlert(error.response.data.error, 'danger')
            }
            else {
              this.addAlert('There was an error submitting your contact request!', 'danger')
            }
            this.isLoading = false
          }
        }
      }
    },
    mixins: [global_mixin]
  }
</script>



// WEBPACK FOOTER //
// core/vue/components/CommercialContactForm.vue